import Section from "../Section";
import Pagination from '../global/Pagination';
import Parallax from '../global/Parallax';
import QuickAdd from '../global/QuickAdd';

export default class CollectionSection extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.element = element;
    this.theme = theme;

    this.initPagination();
    this.loadQuickAdd();
    this.initParallax();

    this.theme.addBadges(this.element, 1000);

    document.addEventListener('shopify:section:load', () => {
      this.initParallax();
    });

    document.addEventListener('paginate', this.initPagination);
    document.addEventListener('shopify:section:select', this.initParallax);
    document.addEventListener('shopify:section:deselect', this.initParallax);
    document.addEventListener('shopify:section:reorder', this.initParallax);
  }

  initParallax = () => {
    // collection image is outside of main div, need to call it on parent
    this.parallax = new Parallax(this.theme, this.element.parentNode);
  }

  initPagination = () => {
    this.pagination = new Pagination(this.theme, this.element, this.loadQuickAdd);
  }

  loadQuickAdd = () => {
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
  }

  // check if we're on mobile
  isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
}
